document.addEventListener("DOMContentLoaded", function() {
    const linkTextElement = document.querySelector('.collections-nav-item__text');
    
    function updateLinkText() {
        if (window.innerWidth >= 992) {
            linkTextElement.textContent = "All Products";
        } else {
            linkTextElement.textContent = "All";
        }
    }

    updateLinkText();

    window.addEventListener('resize', updateLinkText);
});